<script setup>
const props = defineProps({
    record: Object
});

</script>

<template>
    <div class="row">
        <div class="col-6">
            <!-- Falsche Ausdrücke -->
            <ul class="list-group ml-2">
                <template v-for="exp in record.expressions">
                    <li v-if="exp.priority == 0" class="list-group-item text-danger">{{ exp.full_expression }}</li>
                </template>
            <!-- Richtige Ausdrücke -->
                <template v-for="exp in record.expressions">
                    <li v-if="exp.priority > 0" class="list-group-item text-success">{{ exp.full_expression }}</li>
                </template>
            </ul>
        </div>
    </div>
</template>

<style scoped>
.list-group-item{
    padding: .25rem .5rem;
}
</style>
